require("./bootstrap");

import Vue from "vue";

import DataTable from "./components/DataTable";
import { ServerTable, ClientTable, Event } from "vue-tables-2";
import TailwindTheme from "./themes/tailwind";
import UserModule from "./components/User";
import UserInfo from "./components/UserInfo";
import ProjectModule from "./components/Project.vue";
import VehicleModule from "./components/Vehicle.vue";
import AdminModule from "./components/Admin.vue";
import HoursConfirmation from "./components/HoursConfirmation.vue";
import UnconfirmedHoursConfirmation from "./components/UnconfirmedHoursConfirmation.vue";
import ReportsModule from "./components/Reports.vue";
import VehicleReportsModule from "./components/VehicleReports.vue";
import CustomerModule from "./components/Customer.vue";
import PriceModule from "./components/Price.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import MonthLockDataTable from "./components/MonthLockDataTable";
import OdooSyncLog from "./components/OdooSyncLog.vue";
import WorkHourDetailsModal from "./components/WorkHourDetailsModal.vue";
import WorkHoursTable from "./components/WorkHoursTable.vue";

Vue.use(Loading, {
    color: '#000000',
    loader: 'spinner',
    width: 64,
    height: 64,
    backgroundColor: '#ffffff',
    opacity: 0.3,
    zIndex: 999,
    blur: null
});

Vue.mixin({
    data() {
        return {
            loaderInstance: null,
        };
    },
    methods: {
        route: route,
        showLoader(options = {}) {
            this.loaderInstance = this.$loading.show(options);
        },
        hideLoader() {
            if (this.loaderInstance) {
                this.loaderInstance.hide();
            }
        },
    },
});

Vue.use(ServerTable, {}, false, TailwindTheme);

window.Bus = new Vue();
window.Event = Event;
window.moment = require("moment");

const App = new Vue({
    el: "#app",

    components: {
        DataTable,
        UserModule,
        UserInfo,
        ProjectModule,
        VehicleModule,
        AdminModule,
        HoursConfirmation,
        UnconfirmedHoursConfirmation,
        ReportsModule,
        VehicleReportsModule,
        CustomerModule,
        PriceModule,
        MonthLockDataTable,
        OdooSyncLog,
        WorkHourDetailsModal,
        WorkHoursTable
    },

    data() {
        return {
            user: window.App.user,
            isLoading: false,
        };
    },
});

window.App = App;
global.Vue = App;

let alerts = document.querySelectorAll(".alert");

if (alerts.length > 0) {
    alerts.forEach(function (alertModal) {
        setTimeout(() => {
            alertModal.remove();
        }, 10000);
    });
}
